import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcIntegration = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M12.624 6.454a3 3 0 1 0-5.249 0c.126.227-.023.546-.282.546H5a2 2 0 0 0-2 2v4h5v-1.553a.65.65 0 0 1 1.082-.485l2.871 2.552a.65.65 0 0 1 0 .972l-2.871 2.552A.65.65 0 0 1 8 16.552V15H3v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2.093c0-.26.319-.408.546-.282a3 3 0 1 0 0-5.249c-.227.125-.546-.024-.546-.283V9a2 2 0 0 0-2-2h-2.093c-.26 0-.408-.319-.283-.546Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcIntegration");

export { IcIntegration };
//# sourceMappingURL=ic-integration.js.map
